import React from 'react';
import { Button } from '@progress/kendo-react-buttons';

const EditButton = ({ onEdit, disabled, editEnabled }) => (
    <Button
      onClick={onEdit}
      disabled={disabled}
      className="k-button k-button-solid-primary"
      icon="k-icon k-i-edit"
    >
      {editEnabled ? 'Cancel Edit' : 'Edit'}
    </Button>
  );

export default EditButton;
